"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIsMsite = exports.platformName = exports.isMsite = void 0;
// This module should return functions instead of properties.
// It's hard to mock properties in tests
// because they are set as soon as the module is required
// and can't be overriden per test case in the same file.

var platformName = exports.platformName = 'web';
var isMsite = exports.isMsite = false;
var setIsMsite = exports.setIsMsite = function setIsMsite(newIsMsite) {
  exports.isMsite = isMsite = newIsMsite;
};